/**
 * The "changed" badge (PRD-0075 R-C2): the entity was merged or one of its properties changed in
 * the last 30 days. The same for everyone — no per-user "seen" state. Presentational: whether to
 * show it is the caller's (`features/entity-history`).
 */
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils/cn'

export function ChangedBadge({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <Badge
      variant="info"
      title={t('investigations.entityDetail.history.changedHint')}
      className={cn('h-4 px-1.5 text-4xs uppercase tracking-wide', className)}
    >
      {t('investigations.entityDetail.history.changed')}
    </Badge>
  )
}
